import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {selectedSiteId} from '../../store';
import SiteAlertContainer from './SiteAlertContainer';

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      siteId: selectedSiteId(),
    };
  }

  handleError(error) {
    this.setState({
      error: error,
    });
  }

  render() {
    return (
      <div>
        <SiteAlertContainer />
      </div>
    );
  }
}

Dashboard.propTypes = {
  batteryAlerts: PropTypes.array,
  feeds: PropTypes.array,
};

Dashboard.defaultProps = {};

const mapStateToProps = function(store) {
  return {
    batteryAlerts: store.dashboardState.batteryAlerts,
    feeds: store.dashboardState.feeds,
  };
};

export default connect(mapStateToProps)(Dashboard);
